import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 py-16 text-center" data-testid="payment-cancel">
      <XCircle className="w-16 h-16 text-labor-muted mx-auto mb-6" />
      <h1 className="font-display text-3xl">Pagamento annullato</h1>
      <p className="text-labor-muted mt-3">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
      <div className="mt-6 flex gap-3 justify-center">
        <Link to="/profilo" className="olive-btn px-6 py-3 font-semibold">Torna al profilo</Link>
        <Link to="/" className="border border-labor-border px-6 py-3 font-semibold">Home</Link>
      </div>
    </div>
  );
}
